import { PeriodToTC, compare } from '../../utils/date';
import { t } from 'src/i18n/config';

export const listSerializer = (res) => {
  return res
    .map((obj) => {
      const {
        patientName: name,
        patientAlias: alias,
        appointmentDate,
        appointmentPeriod: time,
        appointmentDoctorName: doctorName,
        appointmentSubjectName: subject,
        appointmentCurrentSeq: currentNumber,
        appointmentSeq: number,
        appointmentWaitingCount: waiting,
        appointmentDeletedAt: deletedAt,
        appointmentTime,
        createdBy,
        service,
      } = obj;
      const id = obj.appointmentId || obj.appointmentID;
      const room = obj.appointmentRoomId || obj.appointmentRoomID;
      const cancelable = !!obj.appointmentCancelId || !!obj.cancelID;

      return {
        id,
        name,
        relation: alias || t('self'),
        date: new Date(`${appointmentDate}T00:00:00`), // e.g. 2025-05-29T00:00:00
        time: PeriodToTC(time) || time,
        doctorName,
        subject,
        room,
        currentNumber,
        number: `${number}`,
        waiting,
        cancelable,
        deleted: deletedAt != null,
        appointmentTime,
        createdBy,
        service,
      };
    })
    .sort(compare);
};

export const fuyuanAppointmentListSerializer = (res) => {
  return (res || [])
    .map((obj) => {
      const {
        appointmentID: id,
        patientName: name,
        appointmentDate,
        appointmentPeriod: time,
        appointmentDoctorName: doctorName,
        appointmentSubjectName: subject,
        appointmentRoomName: room,
        appointmentSeq: number,
        appointmentDeletedAt: deletedAt,
        appointmentTime,
        cancelID,
      } = obj;

      return {
        id,
        name,
        date: new Date(`${appointmentDate}T00:00:00`),
        rawDate: appointmentDate,
        rawPeriod: time,
        time: PeriodToTC(time) || time,
        doctorName,
        subject,
        room,
        number: `${number}`,
        cancelable: !!cancelID,
        deleted: deletedAt != null,
        appointmentTime,
      };
    })
    .sort(compare);
};

export const currentProgressSerializer = (list) => (res) => {
  const listByRoomIdDoctorName = (list || []).reduce((s, t) => {
    s[`${t.room}-${t.doctorName}`] = t;
    return s;
  }, {});

  res.forEach((a) => {
    listByRoomIdDoctorName[`${a.roomId}-${a.doctorName}`] = {
      ...listByRoomIdDoctorName[`${a.roomId}-${a.doctorName}`],
      ...a,
    };
  });
  return Object.keys(listByRoomIdDoctorName).map(
    (s) => listByRoomIdDoctorName[s]
  );
};
